import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useUser } from "../contexts/UserContext";

import { logout } from "../services/auth";
import { useState, useEffect } from "react";
import {
    updateUserProfile,
} from "../services/user";
import {
    getCompletedCount,
    getCompletedModuleCount,
} from "../services/progress";
import {
    changePassword,
} from "../services/auth";


export default function Account() {
    const navigate = useNavigate();
    const { user } = useAuth();
    const { profile } = useUser();
    const [displayName, setDisplayName] =
        useState("");

    const [emailUpdates, setEmailUpdates] =
        useState(false);

    const [saving, setSaving] =
        useState(false);
    const [newPassword, setNewPassword] =
        useState("");

    const [changingPassword, setChangingPassword] =
        useState(false);

    const [completedCount, setCompletedCount] =
        useState(0);

    const [modulesCompleted, setModulesCompleted] =
        useState(0);

    useEffect(() => {

        if (!profile) return;

        setDisplayName(
            profile.displayName || ""
        );

        setEmailUpdates(
            profile.emailUpdates || false
        );

    }, [profile]);

    useEffect(() => {

        if (!user) return;

        async function loadCount() {

            const [
                activityCount,
                moduleCount,
            ] = await Promise.all([
                getCompletedCount(),
                getCompletedModuleCount(),
            ]);

            setCompletedCount(activityCount);
            setModulesCompleted(moduleCount);

        }

        loadCount();

    }, [user]);

    async function handleSave() {

        try {

            setSaving(true);

            await updateUserProfile({

                displayName,

                emailUpdates,

            });

        } finally {

            setSaving(false);

        }

    }
    async function handleChangePassword() {

        if (newPassword.length < 6) {

            alert(
                "Password must be at least 6 characters."
            );

            return;

        }

        try {

            setChangingPassword(true);

            await changePassword(
                newPassword
            );

            alert(
                "Password changed successfully."
            );

            setNewPassword("");

        } catch (error) {

            if (
                error.code ===
                "auth/requires-recent-login"
            ) {

                alert(
                    "Please log in again before changing your password."
                );

            } else {

                alert(error.message);

            }

        } finally {

            setChangingPassword(false);

        }

    }
    async function handleLogout() {

        await logout();

        navigate("/", { replace: true });

    }

    return (

        <div
    className="page"
    style={{
        paddingTop: "calc(env(safe-area-inset-top) + 20px)"
    }}
>
            <Link to="/" className="safe-top-link">
    ← Home
</Link>
            <h1>My Account</h1>
            <hr />

            <h2>Profile</h2>

            <div>
                <label>Name</label>

                <input
                    value={displayName}
                    onChange={(e) =>
                        setDisplayName(e.target.value)
                    }
                />
            </div>

            <p>
                <strong>Email:</strong>{" "}
                {profile?.email || user?.email}
            </p>
            <label>
                <input
                    type="checkbox"
                    checked={emailUpdates}
                    onChange={(e) =>
                        setEmailUpdates(e.target.checked)
                    }
                />

                Receive occasional update emails
            </label>
            <hr />

            <h2>Progress</h2>
            <p>
                <strong>Activities Completed:</strong>{" "}
                {completedCount}
            </p>
            <p>
                <strong>Modules Completed:</strong>{" "}
                {modulesCompleted}
            </p>

            <h2>Account</h2>
            <p>
                <strong>Member since:</strong>{" "}
                {profile?.createdAt
                    ? profile.createdAt.toDate().toLocaleDateString()
                    : "Loading..."}
            </p>
                        <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "1rem",
                    flexWrap: "wrap",
                }}
            >
                <button
                    onClick={handleSave}
                    disabled={saving}
                >
                    {saving
                        ? "Saving..."
                        : "Save Changes"}
                </button>

                <input
                    type="password"
                    placeholder="New password"
                    value={newPassword}
                    onChange={(e) =>
                        setNewPassword(
                            e.target.value
                        )
                    }
                />

                <button
                    onClick={handleChangePassword}
                    disabled={changingPassword}
                >
                    {changingPassword
                        ? "Changing..."
                        : "Change Password"}
                </button>
            </div>

            <button
                onClick={handleLogout}
            >
                Log Out
            </button>

            <p style={{ marginTop: "2rem" }}>
                <Link
                    to="/delete-account"
                    style={{ color: "#c62828" }}
                >
                    Request Account Deletion
                </Link>
            </p>

        </div>

    );


}